export const DISPLAY_STATUSES = {
  refunded: 'refunded',
  reversed: 'reversed',
  refundNeedsResponse: 'refundNeedsResponse',
  refund_needs_response: 'refundNeedsResponse',
  refundDebitRequiresAction: 'refundDebitRequiresAction',
  refund_debit_requires_action: 'refundDebitRequiresAction',
  canceled: 'canceled',
  blocked: 'blocked',
  failed: 'failed',
  expired: 'expired',
  pending: 'pending',
  incomplete: 'incomplete',
  uncaptured: 'uncaptured',
  pendingRefund: 'pendingRefund',
  pending_refund: 'pendingRefund',
  partialRefund: 'partialRefund',
  partial_refund: 'partialRefund',
  partiallyReversed: 'partiallyReversed',
  partially_reversed: 'partiallyReversed',
  disputed: 'disputed',
  succeeded: 'succeeded',
  earlyFraudWarning: 'earlyFraudWarning',
  early_fraud_warning: 'earlyFraudWarning',
  partialCapture: 'partialCapture',
  partial_capture: 'partialCapture',
  partiallyPaid: 'partiallyPaid',
  multipleDisputes: 'multipleDisputes',
  prevented: 'prevented',
  lost: 'lost',
  won: 'won',
} as const;

export type DisplayStatus = keyof typeof DISPLAY_STATUSES;
